import { useAutomaticConciliation } from './useAutomaticConciliation'
import AutomaticConciliationModal from './AutomaticConciliationModal'
import AutomaticConciliationButton from './AutomaticConciliationButton'
import { useState, useContext, useEffect, useRef, useMemo } from 'react'
import GlobalContext from '../../../../../../../context/global-context'
import { sileo } from 'sileo'
import LoaderAdm from '../../../../../../../assets/svgIcons/LoaderAdm.json'
import Lottie from 'lottie-react'
import { getWidgetToken } from '../../bancos/modalConectFintoc/contectModalStep'
import PowerIcon from '@mui/icons-material/Power'
import PowerOffIcon from '@mui/icons-material/PowerOff'
import { Button, Select } from '../../../../../ui/index'
import TableMovements from './Table'
import { BankAPI } from '../../../../../../../api/bancos.api'
import integrationsAPI from '../../../../../../../api/integrations.api'
import ExportToXlsxModal from '../../../../../modals/ExportToXlsxModal'
import ModalCreditCardStatement from '../modalDialogCreate/ModalCreditCardStatement'
import ModalCreditCardStatementIntro from '../modalDialogCreate/ModalCreditCardStatementIntro'
import CreditCardStatementApi from '../../../../../../../api/creditCardStatement.api'
import CreditCardIcon from '@mui/icons-material/CreditCard'
import businessApi from '../../../../../../../api/business.api'
import {
  currentMonth,
  currentYear,
  monthsOptions as months,
  yearsOptions,
  REACT_APP_MERCADOPAGO_REDIRECT_URI,
  SHOW_NEW_GLOBAL66_BANK,
  CREDIT_CARDS_ALLOWED,
  getLatestMovementMonth
} from '../../../../../../utils/constant'
//import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
//import clsx from 'clsx'
import CustomPagination from '../../../../../table/CustomPagination'
import SearchFilter from '../../../../../ui/SearchFilter'
import mercadoPagoLogo from '../../../../../../../assets/iconosBancos/mercadoPago.jpg'
import global66Logo from '../../../../../../../assets/iconosBancos/global66.png'
import bancoChileLogo from '../../../../../../../assets/iconosBancos/bancoChile.jpeg'
import bancoEstadoLogo from '../../../../../../../assets/iconosBancos/bancoEstado.jpeg'
import bancoSantanderLogo from '../../../../../../../assets/iconosBancos/bancoSantander.jpeg'
import mercadoPagoAuthImage from '../../../../../../../assets/integrations/mercado-pago-auth.png'

// ⬇️ NUEVO: puente y store
import BankBridge from './BankBridge'
import { useBanks } from '../useBanks.hook'
import AdministrationDashboard from '../../dashboard'
import { useInfiniteBankTransactions } from '../../../../../../../hooks/useInfiniteBankTransactions'
import { useInfiniteScroll } from '../../../../../../../hooks/useInfiniteScroll'
import { useAdministracionTabs } from '../../../../../../../pages/useAdministracion.hooks'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { useSummaryMovementsOverrides } from '../../../../../../../pages/useAdministracion.hooks'
import { QueryKeys } from '../../../../../../../queries/querykeys'
import PlanRestrictedButton from '../../../../../ui/PlanRestrictedButton'
import Global66IntegrationFlow from '../../../Ajustes/Integraciones/Global66IntegrationFlow'
import { usePlanPermissions } from '../../../../../../../hooks/usePlanPermissions'
//import PowerOnIcon from '@mui/icons-material/PowerSettingsNewOutlined';
//import AutoIcon from '@mui/icons-material/AutoFixHighOutlined';

const CREDIT_CARD_BANK_ACCOUNT_TYPE_ID = 10 // bank_account_type.name = 'Tarjeta de Crédito'

const generateMercadoPagoAccountId = () => {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID()
  }
  return `mp-${Date.now()}-${Math.random().toString(36).slice(2)}`
}

const List = ({ currentAcount, dataSaldo }) => {
  const [monthFilter, setMonthFilter] = useState(0)
  const [latestMovementMonth, setLatestMovementMonth] = useState(null)
  const [yearFilter, setYearFilter] = useState(currentYear)
  const [rowsPerPage, setRowsPerPage] = useState(-1)
  const { currentBusiness } = useContext(GlobalContext)
  const [searchQuery, setSearchQuery] = useState('')
  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState('')
  const [highlightedRows, setHighlightedRows] = useState({})
  const [selectedFilter, setSelectedFilter] = useState('')
  const [isOpen, setIsOpen] = useState(false)
  const [selectedBank, setSelectedBank] = useState('')
  const [, setDeudasPagos] = useState({ porPagar: 0, porCobrar: 0 })
  const bankAPI = new BankAPI()
  const selectRef = useRef(null)
  const [page, setPage] = useState(0)
  const [order, setOrder] = useState({ col: '', field: '', direction: 'asc' })
  const [dataPermiso, setDataPermiso] = useState({})
  const [showConnectMethodModal, setShowConnectMethodModal] = useState(false)
  const [showMercadoPagoInfoModal, setShowMercadoPagoInfoModal] = useState(false)
  const [showMercadoPagoConnectModal, setShowMercadoPagoConnectModal] = useState(false)
  const [mercadoPagoAccessToken, setMercadoPagoAccessToken] = useState('')
  const [isConnectingMercadoPago, setIsConnectingMercadoPago] = useState(false)
  const [mercadoPagoIntegrated, setMercadoPagoIntegrated] = useState(false)
  const [global66Integrated, setGlobal66Integrated] = useState(false)
  const [showGlobal66Modal, setShowGlobal66Modal] = useState(false)
  const [global66ModalKey, setGlobal66ModalKey] = useState(0)
  const [isExportModalOpen, setIsExportModalOpen] = useState(false)
  const [isExporting, setIsExporting] = useState(false)
  const [showCreditCardStatementModal, setShowCreditCardStatementModal] = useState(false)
  const [showCreditCardStatementIntroModal, setShowCreditCardStatementIntroModal] = useState(false)
  const { activeTab } = useAdministracionTabs()
  const queryClient = useQueryClient()
  const overrides = useSummaryMovementsOverrides(state => state.overrides)

  const creditCardStatementIntroPreferenceQuery = useQuery({
    queryKey: ['credit-card-statement-intro-preference', currentBusiness?.id],
    queryFn: () => CreditCardStatementApi.getIntroPreference(currentBusiness.id),
    enabled: Boolean(currentBusiness?.id),
    staleTime: 5 * 60 * 1000
  })
  const { userMe, plan, subscriptionExpired, canAddBank } = usePlanPermissions()
  //const [isAutomatic, setIsAutomatic] = useState(true);

  //const toggleMode = () => {
  // setIsAutomatic(!isAutomatic);
  //};

  // ⬇️ NUEVO: estado del puente desde el store (defensivo por si aún no expanden el hook)
  const bankBridge = useBanks(s => s.bankBridge) || {}
  const localBanksCount = useBanks(s => s.banksCount)
  const resetBankBridge = useBanks(s => s.resetBankBridge)
  const showBridge = useMemo(() => {
    return (
      bankBridge?.isFirstForBusiness &&
      (bankBridge?.state === 'starting' || bankBridge?.state === 'running')
    )
  }, [bankBridge?.isFirstForBusiness, bankBridge?.state])

  useEffect(() => {
    if (!showBridge && !transactions.length) {
      refetch(true)
    }
  }, [showBridge])

  const {
    data: infiniteData,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoading,
    refetch
  } = useInfiniteBankTransactions({
    businessId: currentBusiness?.id || 0,
    productId: currentAcount?.id || 0,
    year: yearFilter,
    month: monthFilter || undefined,
    limit: rowsPerPage > 0 ? rowsPerPage : 500,
    page: page,
    filters: {
      searchQuery: debouncedSearchQuery,
      transactionType: selectedFilter !== 'destacados' ? selectedFilter : undefined,
      account: selectedBank
    }
  })

  const { lastElementRef } = useInfiniteScroll({
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage
  })

  useEffect(() => {
    if (bankBridge?.state === 'done') {
      if (typeof resetBankBridge === 'function') resetBankBridge()
    }
  }, [bankBridge?.state])

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchQuery(searchQuery)
    }, 300)

    return () => clearTimeout(timer)
  }, [searchQuery])

  useEffect(() => {
    const fetchMercadoPagoStatus = async () => {
      if (!currentBusiness?.id) return

      try {
        const response = await integrationsAPI.getIntegrationsStatus(currentBusiness.id)
        setMercadoPagoIntegrated(response.data?.mercadopago?.integrated || false)
      } catch (error) {
        console.error('Error fetching Mercado Pago integration status:', error)
      }
    }

    fetchMercadoPagoStatus()
  }, [currentBusiness?.id])

  useEffect(() => {
    if (!SHOW_NEW_GLOBAL66_BANK) return

    const fetchGlobal66Status = async () => {
      if (!currentBusiness?.id) return
      try {
        const response = await integrationsAPI.getIntegrationsStatus(currentBusiness.id)
        setGlobal66Integrated(response.data?.global66?.integrated || false)
      } catch {
        // integration not configured
      }
    }
    fetchGlobal66Status()
  }, [currentBusiness?.id])

  useEffect(() => {
    if (activeTab === 'bancos' && !showBridge) {
      refetch(true)
    }
  }, [activeTab, refetch, showBridge])

  useEffect(() => {
    if (!activeTab || showBridge) return
    refetch(true)
  }, [activeTab, refetch, showBridge])

  useEffect(() => {
    if (!activeTab || showBridge) return
    queryClient.removeQueries({ queryKey: [QueryKeys.BANK_TRANSACTIONS], exact: false })
  }, [activeTab, queryClient, showBridge])

  const transactions = useMemo(() => {
    const base = infiniteData?.pages?.flatMap(page => page.data) || []

    const overridesById =
      overrides && Object.keys(overrides).length > 0
        ? new Map(
            Object.entries(overrides).map(([key, value]) => [
              Number(key),
              value
            ])
          )
        : null

    return base.map(originalRow => {
      return (
        overridesById?.get(Number(originalRow?.id)) ??
        originalRow
      )
    })
  }, [
    infiniteData,
    overrides
  ])

  useEffect(() => {
    setLatestMovementMonth(null)
  }, [currentBusiness?.id, currentAcount?.id, yearFilter])

  useEffect(() => {
    if (monthFilter !== 0 || !infiniteData?.pages) return
    const latestMonth = getLatestMovementMonth(transactions, yearFilter)
    setLatestMovementMonth(current => Math.max(current ?? 0, latestMonth))
  }, [infiniteData?.pages, monthFilter, transactions, yearFilter])

  const icons = [
    <button
      key='export-xlsx'
      className='w-10 h-10 text-green-700 font-bold cursor-pointer rounded-full shadow bg-white'
      onClick={() => setIsExportModalOpen(true)}
    >
      XLS
    </button>
  ]

  const monthsOptionsWithAll = [
    { value: 0, label: 'Todos los meses' },
    ...months.map(monthOption => ({
      ...monthOption,
      disabled: monthOption.value > Math.max(
        Number(yearFilter) < currentYear
          ? 12
          : Number(yearFilter) === currentYear
            ? currentMonth
            : 0,
        latestMovementMonth ?? 0
      )
    }))
  ]

  const formatAccountName = account => {
    return account.numeroCuentaBanco === 'ALL'
      ? account.nombreCuentaBanco
      : `${account.nombreCuentaBanco} - ${account.numeroCuentaBanco}`
  }

  const accountOptions = useMemo(() => {
    const accountOptions = [
      {
        nombreCuentaBanco: 'Todas las cuentas',
        numeroCuentaBanco: 'ALL',
        id: ''
      }
    ]

    if (!dataSaldo.data) return accountOptions

    for (const account of dataSaldo.data) {
      if (account.bank.name === 'Caja Principal') {
        if (String(account.numeroCuenta ?? '').trim() === '-1') continue

        accountOptions.push({
          nombreCuentaBanco: account.bank.name,
          numeroCuentaBanco: account.numeroCuenta === '0' ? 'CAJA' : account.numeroCuenta,
          id: account.id
        })
      } else {
        const isCreditCard = account.cuentaTipoId === CREDIT_CARD_BANK_ACCOUNT_TYPE_ID
        const isUsdCreditCard = isCreditCard && (account.tipoDivisa?.name === 'USD' || account.tipoDivisaId === 2)
        accountOptions.push({
          nombreCuentaBanco: isUsdCreditCard
            ? `T.C USD ${account.bank.name}`
            : isCreditCard
              ? `T.C ${account.bank.name}`
              : account.bank.name,
          numeroCuentaBanco: isCreditCard
            ? `XXXX-${account.numeroCuenta}`
            : account.numeroCuenta,
          id: account.id
        })
      }
    }

    if (!accountOptions.find(account => account.nombreCuentaBanco === 'Caja Principal')) {
      accountOptions.push({
        nombreCuentaBanco: 'Caja Principal',
        numeroCuentaBanco: 'CAJA',
        id: 'CAJA'
      })
    }

    return accountOptions
  }, [dataSaldo])

  const handleBankSelection = account => {
    if (account.numeroCuentaBanco === 'ALL') {
      setSelectedBank('')
    } else {
      setSelectedBank(account.id)
    }
    setIsOpen(false)
  }

  const options = [
    { label: 'Destacados', value: 'destacados' },
    { label: 'Abono', value: 'ABONO' },
    { label: 'Cargo', value: 'CARGO' },
    { label: 'Pendiente', value: 'PENDIENTE' },
    { label: 'Conciliado', value: 'CONCILIADO' },
    { label: 'Parcialmente conciliado', value: 'PARCIALMENTE_CONCILIADO' }
  ]

  useEffect(() => {
    const storedHighlights = localStorage.getItem('highlightedRows')
    if (storedHighlights) setHighlightedRows(JSON.parse(storedHighlights))
  }, [])

  useEffect(() => {
    if (Object.keys(highlightedRows).length > 0) {
      localStorage.setItem('highlightedRows', JSON.stringify(highlightedRows))
    }
  }, [highlightedRows])

  const toggleHighlight = idOrIds => {
    setHighlightedRows(prev => {
      if (Array.isArray(idOrIds)) {
        const allOn = idOrIds.every(id => prev[id])
        const newAcc = { ...prev }
        idOrIds.forEach(id => {
          newAcc[id] = !allOn
        })
        return newAcc
      }
      return { ...prev, [idOrIds]: !prev[idOrIds] }
    })
  }

  const handleExport = async email => {
    setIsExporting(true)
    try {
      await businessApi.exportMovementsTransactions({
        organizationId: currentBusiness.organizationId,
        businessId: currentBusiness.id,
        productId: currentAcount?.id || 0,
        email,
        year: yearFilter,
        month: monthFilter || undefined,
        searchQuery: debouncedSearchQuery || undefined,
        account: selectedBank || undefined,
        transactionType: selectedFilter !== 'destacados' ? selectedFilter || undefined : undefined
      })
    } catch (error) {
      console.error('Error al exportar:', error)
      throw error
    } finally {
      setIsExporting(false)
    }
  }

  const fetchDeudasPagos = async () => {
    try {
      const response = await bankAPI.getTotalDeudasPagos(currentBusiness.id)
      setDeudasPagos(response.data)
    } catch (error) {
      sileo.error({
        title: 'Error de Datos',
        description: (
          <span className='text-red-500/80 font-medium'>
            No se pudieron cargar los datos de deudas y pagos
          </span>
        )
      })
      console.error('Error al obtener deudas y pagos:', error)
    }
  }

  useEffect(() => {
    if (currentBusiness) {
      fetchDeudasPagos()
    }
  }, [currentBusiness])

  useEffect(() => {
    const handleClickOutside = event => {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setIsOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  useEffect(() => {
    if ((!dataSaldo?.data || dataSaldo.data.length === 0) && !selectedBank) {
      setSelectedBank('')
    }
  }, [dataSaldo])

  const getValidaciones = async () => {
    try {
      const response = await bankAPI.getPermisos(currentBusiness.id)
      setDataPermiso(response.data)
    } catch (error) {
      console.error(error)
    } finally {
      // noop
    }
  }

  useEffect(() => {
    getValidaciones()
  }, [currentBusiness.id])

  const handleAddNewBank = () => {
    console.info('[Bancos][Agregar] Click en agregar banco', {
      businessId: currentBusiness?.id,
      banksCount: userMe?.banksCount ?? localBanksCount ?? 0,
      maxBanks: plan?.maxBanks ?? 0,
      subscriptionExpired,
      canAddBank: canAddBank()
    })
    setShowConnectMethodModal(true)

    if (isAutomaticConciliation) {
      void updateAutomaticConciliationState('no-auto', {
        silent: true,
        skipCurrentBusinessSync: true
      })
    }
  }

  const handleSelectMercadoPago = () => {
    setShowConnectMethodModal(false)
    setShowMercadoPagoInfoModal(true)
  }

  const handleConfirmMercadoPago = async () => {
    if (!currentBusiness?.id) {
      sileo.error({
        title: 'Error de Información',
        description: (
          <span className='text-red-500/80 font-medium'>
            No se pudo obtener la información del negocio
          </span>
        )
      })
      return
    }

    try {
      const mpAccountId = generateMercadoPagoAccountId()
      const response = await integrationsAPI.getMercadoPagoOAuthUrl(currentBusiness.id, {
        redirect_uri: `${REACT_APP_MERCADOPAGO_REDIRECT_URI}?businessId=${currentBusiness.id}&mpAccountId=${mpAccountId}`,
        organization_id: currentBusiness.organizationId
      })

      if (response.data?.url) {
        window.open(response.data.url, '_blank')
      } else {
        sileo.error({
          title: 'Error de Conexión',
          description: (
            <span className='text-red-500/80 font-medium'>
              No se pudo obtener la URL de autorización de Mercado Pago
            </span>
          )
        })
      }
    } catch (error) {
      console.error('Error al conectar con Mercado Pago:', error)
      const errorMessage =
        error?.response?.data?.message ||
        'Error al conectar con Mercado Pago. Por favor, intenta nuevamente.'
      sileo.error({
        title: 'Error de Integración',
        description: <span className='text-red-500/80 font-medium'>{errorMessage}</span>
      })
    }
  }

  useEffect(() => {
    const handleMessage = event => {
      if (event.origin !== window.location.origin) return

      if (event.data.type === 'MERCADOPAGO_OAUTH_SUCCESS') {
        sileo.success({
          title: 'Conexión Exitosa',
          description: (
            <span className='text-green-500/80 font-medium'>
              Mercado Pago ha sido conectado exitosamente. Tus transacciones estarán en Luca en unos
              minutos
            </span>
          )
        })
        setShowMercadoPagoInfoModal(false)
        setMercadoPagoIntegrated(true)
        if (refetch) {
          refetch(true)
        }
      } else if (event.data.type === 'MERCADOPAGO_OAUTH_ERROR') {
        sileo.error({
          title: 'Error de Autenticación',
          description: (
            <span className='text-red-500/80 font-medium'>
              {event.data.message || 'Error al conectar con Mercado Pago'}
            </span>
          )
        })
      }
    }

    window.addEventListener('message', handleMessage)
    return () => {
      window.removeEventListener('message', handleMessage)
    }
  }, [refetch])

  const handleSelectGlobal66 = async () => {
    if (global66Integrated) {
      sileo.info({
        title: 'Cuenta Vinculada',
        description: (
          <span className='text-blue-500/80 font-medium'>
            Ya tienes Global66 vinculado con {currentBusiness?.name || 'este negocio'}
          </span>
        )
      })
      setShowConnectMethodModal(false)
      return
    }
    setShowConnectMethodModal(false)
    setGlobal66ModalKey(key => key + 1)
    setShowGlobal66Modal(true)
  }

  const handleSelectOtherBanks = () => {
    console.info('[Bancos][Agregar] Abriendo widget bancario', {
      businessId: currentBusiness?.id,
      banksCount: userMe?.banksCount ?? localBanksCount ?? 0,
      maxBanks: plan?.maxBanks ?? 0,
      subscriptionExpired,
      canAddBank: canAddBank()
    })
    setShowConnectMethodModal(false)
    getWidgetToken(currentBusiness.id)
  }

  const handleOpenCreditCardStatementModal = () => {
    setShowConnectMethodModal(false)
    if (creditCardStatementIntroPreferenceQuery.data?.hideIntro) {
      setShowCreditCardStatementModal(true)
    } else {
      setShowCreditCardStatementIntroModal(true)
    }
  }

  const handleCreditCardStatementIntroNext = () => {
    setShowCreditCardStatementIntroModal(false)
    setShowCreditCardStatementModal(true)
  }

  const handleConnectMercadoPagoWithToken = async () => {
    if (!currentBusiness?.id) {
      sileo.error({
        title: 'Error de Negocio',
        description: (
          <span className='text-red-500/80 font-medium'>
            No se pudo obtener la información del negocio
          </span>
        )
      })
      return
    }

    if (!mercadoPagoAccessToken.trim()) {
      sileo.error({
        title: 'Token Requerido',
        description: (
          <span className='text-red-500/80 font-medium'>
            Por favor ingresa el access token de Mercado Pago
          </span>
        )
      })
      return
    }

    setIsConnectingMercadoPago(true)

    try {
      await sileo.promise(
        businessApi.connectMercadoPagoWithAccessToken(
          currentBusiness.id,
          mercadoPagoAccessToken.trim()
        ),
        {
          loading: { title: 'Conectando' },
          success: {
            title: '¡Conectado!',
            description: (
              <span className='text-green-500/80 font-medium'>
                Mercado Pago ha sido conectado exitosamente. Tus transacciones estarán en Luca en
                unos minutos
              </span>
            )
          },
          error: {
            title: 'Error de Conexión',
            description: 'Error al conectar Mercado Pago'
          }
        }
      )

      setShowMercadoPagoConnectModal(false)
      setMercadoPagoAccessToken('')
      setMercadoPagoIntegrated(true)

      const getData = useBanks.getState().getData
      if (getData) {
        await getData()
      }

      const setBanksCount = useBanks.getState().setBanksCount
      const banksCount = useBanks.getState().banksCount
      setBanksCount(banksCount + 1)

      if (refetch) {
        refetch(true)
      }
    } catch (error) {
      console.error('Error al conectar MercadoPago:', error)
      const errorMessage =
        error?.response?.data?.message ||
        'Error al conectar con MercadoPago. Por favor, intenta nuevamente.'
      sileo.error({
        title: 'Error de Token',
        description: <span className='text-red-500/80 font-medium'>{errorMessage}</span>
      })
    } finally {
      setIsConnectingMercadoPago(false)
    }
  }

  const handleChangePage = newPage => setPage(newPage)
  const handleChangeRowsPerPage = newRows => {
    setRowsPerPage(newRows)
    setPage(0)
  }

  const handleSort = ({ col, field }) => {
    const isAsc = order.col === col && order.direction === 'asc'
    setOrder({ col, field, direction: isAsc ? 'desc' : 'asc' })
  }

  const hasBankLinked = useMemo(() => {
    const cuentas = dataSaldo?.data ?? []
    return cuentas.some(c => (c.bank?.name || '').toLowerCase() !== 'caja principal')
  }, [dataSaldo])
  const automaticConciliation = useAutomaticConciliation({ hasBankLinked })
  const { isAutomaticConciliation, updateAutomaticConciliationState } = automaticConciliation

  const visibleTransactions = useMemo(() => {
    return transactions.filter(row => {
      if (selectedFilter === 'destacados' && !highlightedRows[row.id]) return false
      const bankName = String(row?.nombreCuentaBanco || '')
        .trim()
        .toLowerCase()
      const description = String(row?.descripcion || '')
        .trim()
        .toLowerCase()

      return !(bankName === 'caja principal' && description.includes('pago comprobante'))
    })
  }, [transactions, selectedFilter, highlightedRows])

  const sortedData = [...visibleTransactions].sort((a, b) => {
    const valA = a[order.field]
    const valB = b[order.field]
    if (valA == null) return 1
    if (valB == null) return -1
    if (order.direction === 'desc') return valA < valB ? -1 : valA > valB ? 1 : 0
    else return valA > valB ? -1 : valA < valB ? 1 : 0
  })

  const paginatedData = sortedData

  const getGroupStatus = subRows => {
    if (!subRows?.length) return 'PENDIENTE'
    const normalized = subRows.map(r => (r.status || '').toUpperCase().replace(/\s+/g, '_'))
    const allConciliado = normalized.every(s => s === 'CONCILIADO')
    const allPendiente = normalized.every(s => s === 'PENDIENTE')
    if (allConciliado) return 'CONCILIADO'
    if (allPendiente) return 'PENDIENTE'
    return 'PARCIALMENTE_CONCILIADO'
  }

  const groupedTransactions = useMemo(() => {
    const groups = {}
    paginatedData.forEach(row => {
      if (!row.fecha) return
      const dateObj = new Date(row.fecha)
      const date = dateObj.toLocaleDateString('es-CL', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      })

      if (!groups[date]) groups[date] = []
      groups[date].push(row)
    })

    const finalGroups = {}
    Object.keys(groups).forEach(date => {
      const rows = groups[date]
      const mpRows = []
      const otherRows = []
      const mpPosRows = []

      rows.forEach(row => {
        const bankName = (row.nombreCuentaBanco || '').toLowerCase()
        const descripcion = (row.descripcion || '').toLowerCase()
        const isMercadoPago = bankName.includes('mercado pago') || bankName.includes('mercadopago')
        const isVentaPresencial =
          descripcion.includes('venta presencial') ||
          descripcion.includes('productos seleccionados')

        if (isMercadoPago && !isVentaPresencial) {
          mpRows.push(row)
        } else if (isMercadoPago && isVentaPresencial) {
          mpPosRows.push(row)
        } else {
          otherRows.push(row)
        }
      })

      const dateGroup = []

      if (mpRows.length > 0) {
        const mpIngresos = mpRows.filter(r => (r.montoAbono || 0) > 0)
        const mpEgresos = mpRows.filter(r => (r.montoCargo || 0) > 0)

        if (mpIngresos.length > 1) {
          const totalAbonoIngresos = mpIngresos.reduce((sum, r) => sum + (r.montoAbono || 0), 0)
          const totalCargoIngresos = mpIngresos.reduce((sum, r) => sum + (r.montoCargo || 0), 0)

          const ingresosRow = {
            id: `mp-group-ingresos-${date}`,
            isGroup: true,
            fecha: mpIngresos[0].fecha,
            nombreCuentaBanco: 'Mercado Pago',
            descripcion: `${mpIngresos.length} ingresos agrupados`,
            montoAbono: totalAbonoIngresos,
            montoCargo: totalCargoIngresos,
            subRows: mpIngresos,
            status: getGroupStatus(mpIngresos)
          }
          dateGroup.push(ingresosRow)
        } else if (mpIngresos.length === 1) {
          dateGroup.push(mpIngresos[0])
        }

        if (mpEgresos.length > 1) {
          const totalAbonoEgresos = mpEgresos.reduce((sum, r) => sum + (r.montoAbono || 0), 0)
          const totalCargoEgresos = mpEgresos.reduce((sum, r) => sum + (r.montoCargo || 0), 0)

          const egresosRow = {
            id: `mp-group-egresos-${date}`,
            isGroup: true,
            fecha: mpEgresos[0].fecha,
            nombreCuentaBanco: 'Mercado Pago',
            descripcion: `${mpEgresos.length} egresos agrupados`,
            montoAbono: totalAbonoEgresos,
            montoCargo: totalCargoEgresos,
            subRows: mpEgresos,
            status: getGroupStatus(mpEgresos)
          }
          dateGroup.push(egresosRow)
        } else if (mpEgresos.length === 1) {
          dateGroup.push(mpEgresos[0])
        }
      }

      if (mpPosRows.length > 0) {
        const mpPosIngresos = mpPosRows.filter(r => (r.montoAbono || 0) > 0)
        const mpPosEgresos = mpPosRows.filter(r => (r.montoCargo || 0) > 0)

        if (mpPosIngresos.length > 1) {
          const totalAbonoPosIngresos = mpPosIngresos.reduce(
            (sum, r) => sum + (r.montoAbono || 0),
            0
          )
          const totalCargoPosIngresos = mpPosIngresos.reduce(
            (sum, r) => sum + (r.montoCargo || 0),
            0
          )

          const ingresosPosRow = {
            id: `mp-pos-group-ingresos-${date}`,
            isGroup: true,
            fecha: mpPosIngresos[0].fecha,
            nombreCuentaBanco: 'Mercado Pago',
            descripcion: `${mpPosIngresos.length} ingresos POS agrupados`,
            montoAbono: totalAbonoPosIngresos,
            montoCargo: totalCargoPosIngresos,
            subRows: mpPosIngresos,
            status: getGroupStatus(mpPosIngresos)
          }
          dateGroup.push(ingresosPosRow)
        } else if (mpPosIngresos.length === 1) {
          dateGroup.push(mpPosIngresos[0])
        }

        if (mpPosEgresos.length > 1) {
          const totalAbonoPosEgresos = mpPosEgresos.reduce((sum, r) => sum + (r.montoAbono || 0), 0)
          const totalCargoPosEgresos = mpPosEgresos.reduce((sum, r) => sum + (r.montoCargo || 0), 0)

          const egresosPosRow = {
            id: `mp-pos-group-egresos-${date}`,
            isGroup: true,
            fecha: mpPosEgresos[0].fecha,
            nombreCuentaBanco: 'Mercado Pago POS',
            descripcion: `${mpPosEgresos.length} egresos POS agrupados`,
            montoAbono: totalAbonoPosEgresos,
            montoCargo: totalCargoPosEgresos,
            subRows: mpPosEgresos,
            status: getGroupStatus(mpPosEgresos)
          }
          dateGroup.push(egresosPosRow)
        } else if (mpPosEgresos.length === 1) {
          dateGroup.push(mpPosEgresos[0])
        }
      }

      otherRows.forEach(r => dateGroup.push(r))

      finalGroups[date] = dateGroup
    })

    return finalGroups
  }, [paginatedData])

  return (
    <>
      <AdministrationDashboard year={yearFilter} highlighnedIndex={0} />

      <div
        className='p-4 mt-6 bg-white rounded-3xl shadow-md flex flex-col'
        style={{ height: 'calc(100vh - 12rem)' }}
      >
        <div className='relative'>
          <div className='absolute top-[-35px] right-0 z-20 flex items-center space-x-2'>
            {icons.map(icon => icon)}
          </div>
        </div>

        {/** ⬇️ NUEVO: mientras corre el puente, mostramos solo el BankBridge */}
        {showBridge ? (
          <BankBridge state={bankBridge?.state} />
        ) : (
          <>
            <div className='flex flex-wrap mt-3 gap-2 items-center mb-4'>
              <Select
                key={`month-${monthFilter}`}
                options={monthsOptionsWithAll}
                defaultValue={monthFilter}
                onChange={e => setMonthFilter(Number(e.target.value))}
              />
              <Select
                key={`year-${yearFilter}`}
                options={yearsOptions}
                defaultValue={yearFilter}
                onChange={e => setYearFilter(e.target.value)}
              />
              <SearchFilter
                value={searchQuery}
                onChange={e => setSearchQuery(e.target.value)}
                filterValues={searchQuery}
                onFilterChange={setDebouncedSearchQuery}
              />
              <select
                value={selectedFilter}
                onChange={e => setSelectedFilter(e.target.value)}
                className='min-w-[90px] border border-gray-300 hover:border-gray-400 focus:border-gray-400 px-4 py-1 pr-6 rounded-full shadow leading-tight text-sm font-sans'
              >
                <option value=''>Todos</option>
                {options.map(opt => (
                  <option key={opt.value} value={opt.value} className='font-sans'>
                    {opt.label}
                  </option>
                ))}
              </select>

              <div className='gap-2'>
                <div className='relative h-full' ref={selectRef}>
                  <div
                    className=' h-full w-[300px] border border-gray-300 hover:border-gray-400 px-3 py-1 rounded-full shadow cursor-pointer text-sm font-sans flex items-center'
                    onClick={() => setIsOpen(!isOpen)}
                  >
                    {formatAccountName(
                      accountOptions.find(account => account.id === selectedBank)
                    ) || 'Todas las cuentas'}
                  </div>
                  {isOpen && (
                    <div
                      className='absolute z-50 left-0 mt-1 min-w-[300px] max-w-[500px] bg-white border border-gray-300 rounded-lg shadow-lg overflow-visible'
                      style={{ top: '100%' }}
                    >
                      {accountOptions.map((account, index) => (
                        <div
                          key={index}
                          className='flex justify-between items-center px-5 py-3 hover:bg-gray-100 cursor-pointer text-sm font-sans whitespace-nowrap'
                          onClick={() => handleBankSelection(account)}
                        >
                          <span>{formatAccountName(account)}</span>
                          {account.numeroCuentaBanco !== 'ALL' && (
                            <span className='text-red-500'>
                              {(account.nombreCuentaBanco || '').toLowerCase() ===
                              'caja principal' ? (
                                <PowerIcon />
                              ) : dataPermiso.banks === 0 ? (
                                <PowerOffIcon />
                              ) : (
                                <PowerIcon />
                              )}
                            </span>
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
              <div className='flex gap-2 items-center'>
                <Button
                  onClick={handleAddNewBank}
                  className='rounded-full bg-accent2 text-white text-sm font-sans'
                  title='AGREGAR BANCO'
                />
                {CREDIT_CARDS_ALLOWED && (
                  <Button
                    onClick={handleOpenCreditCardStatementModal}
                    className='rounded-full bg-accent2 text-white text-sm font-sans'
                    title='AGREGAR MOV. T. DE CRÉDITO'
                  />
                )}
              </div>
              <div className='flex w-full items-center justify-start sm:ml-auto sm:w-auto sm:justify-end'>
                <AutomaticConciliationButton {...automaticConciliation} />
              </div>
            </div>
            {isLoading ? (
              <div className='flex items-center justify-center pt-8 h-full'>
                <Lottie animationData={LoaderAdm} loop style={{ width: 300, height: 300 }} />
              </div>
            ) : (
              <div className='flex-1 min-h-0 overflow-auto pb-2'>
                <TableMovements
                  rows={paginatedData}
                  groupedRows={groupedTransactions}
                  getData={refetch}
                  businessId={currentBusiness?.id}
                  rowsPerPage={rowsPerPage}
                  setRowsPerPage={setRowsPerPage}
                  transactions={transactions}
                  highlightedRows={highlightedRows}
                  toggleHighlight={toggleHighlight}
                  loading={isLoading}
                  onSort={handleSort}
                  order={order}
                  hasBankLinked={hasBankLinked}
                  onAddBank={handleAddNewBank}
                />
                {hasNextPage && (
                  <div ref={lastElementRef} className='flex justify-center py-4'>
                    {isFetchingNextPage ? (
                      <Lottie animationData={LoaderAdm} loop style={{ width: 100, height: 100 }} />
                    ) : (
                      <button
                        onClick={() => fetchNextPage()}
                        className='px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600'
                      >
                        Cargar más
                      </button>
                    )}
                  </div>
                )}
              </div>
            )}

            {(paginatedData?.length > 0 || transactions?.length > 0) && (
              <div className='mt-4'>
                <CustomPagination
                  count={infiniteData?.pages[0]?.count || 0}
                  loadedCount={transactions.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </div>
            )}
          </>
        )}

        {showConnectMethodModal && (
          <div className='fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50'>
            <div className='bg-white rounded-2xl shadow-2xl p-8 w-[480px]'>
              <h2 className='text-2xl font-semibold mb-2 text-gray-800 text-center'>
                Conecta tu cuenta
              </h2>
              <p className='mb-8 text-sm text-gray-600 text-center'>
                Elige cómo deseas agregar tu cuenta bancaria
              </p>
              <div className='flex flex-col space-y-4'>
                <PlanRestrictedButton
                  keepEnabled={true}
                  requiredPermission='allowMercadopagoIntegration'
                  message='La integración con Mercado Pago no está disponible en tu plan actual. Actualiza tu plan para acceder a esta funcionalidad.'
                  canAddAddon={true}
                  className='w-full'
                >
                  <button
                    onClick={handleSelectMercadoPago}
                    className='w-full group relative overflow-hidden bg-white border-2 border-gray-200 rounded-2xl px-6 py-5 hover:border-blue-400 hover:shadow-lg transition-all duration-300 ease-in-out'
                  >
                    <div className='flex items-center space-x-4'>
                      <div className='flex-shrink-0 relative'>
                        <img
                          src={mercadoPagoLogo}
                          alt='Mercado Pago'
                          className='w-16 h-16 object-contain'
                        />
                        {mercadoPagoIntegrated && (
                          <div className='absolute -top-1 -right-1 bg-green-500 text-white rounded-full p-0.5 shadow-sm'>
                            <svg
                              className='w-3.5 h-3.5'
                              fill='none'
                              stroke='currentColor'
                              viewBox='0 0 24 24'
                            >
                              <path
                                strokeLinecap='round'
                                strokeLinejoin='round'
                                strokeWidth={3}
                                d='M5 13l4 4L19 7'
                              />
                            </svg>
                          </div>
                        )}
                      </div>
                      <div className='flex-1 text-left'>
                        <div className='flex items-center gap-2'>
                          <h3 className='text-lg font-semibold text-gray-800 group-hover:text-blue-600 transition-colors'>
                            Mercado Pago
                          </h3>
                          {mercadoPagoIntegrated && (
                            <span className='text-[10px] font-bold bg-green-100 text-green-700 px-2 py-0.5 rounded-full uppercase tracking-wider'>
                              Vinculado
                            </span>
                          )}
                        </div>
                        <p className='text-sm text-gray-500'>
                          {mercadoPagoIntegrated
                            ? `¿Deseas agregar otra cuenta de Mercado Pago para ${
                                currentBusiness?.name || 'este business'
                              }?`
                            : 'Agrega tu banco'}
                        </p>
                      </div>
                      {!mercadoPagoIntegrated && (
                        <svg
                          className='w-6 h-6 text-gray-400 group-hover:text-blue-600 group-hover:translate-x-1 transition-all'
                          fill='none'
                          stroke='currentColor'
                          viewBox='0 0 24 24'
                        >
                          <path
                            strokeLinecap='round'
                            strokeLinejoin='round'
                            strokeWidth={2}
                            d='M9 5l7 7-7 7'
                          />
                        </svg>
                      )}
                    </div>
                  </button>
                </PlanRestrictedButton>

                {SHOW_NEW_GLOBAL66_BANK && (
                  <PlanRestrictedButton
                    checkBankLimit
                    message='Conectar Global66'
                    keepEnabled
                    canAddAddon={true}
                    onClick={handleSelectGlobal66}
                    className='w-full'
                  >
                    <button className='w-full group relative overflow-hidden bg-white border-2 border-gray-200 rounded-2xl px-6 py-5 hover:border-primary hover:shadow-lg transition-all duration-300 ease-in-out'>
                      <div className='flex items-center space-x-4'>
                        <div className='flex-shrink-0 relative'>
                          <img
                            src={global66Logo}
                            alt='Global66'
                            className='w-16 h-16 object-contain rounded-xl'
                          />
                          {global66Integrated && (
                            <div className='absolute -top-1 -right-1 bg-green-500 text-white rounded-full p-0.5 shadow-sm'>
                              <svg
                                className='w-3.5 h-3.5'
                                fill='none'
                                stroke='currentColor'
                                viewBox='0 0 24 24'
                              >
                                <path
                                  strokeLinecap='round'
                                  strokeLinejoin='round'
                                  strokeWidth={3}
                                  d='M5 13l4 4L19 7'
                                />
                              </svg>
                            </div>
                          )}
                        </div>
                        <div className='flex-1 text-left'>
                          <div className='flex items-center gap-2'>
                            <h3 className='text-lg font-semibold text-gray-800 group-hover:text-primary transition-colors'>
                              Global66
                            </h3>
                            {global66Integrated && (
                              <span className='text-[10px] font-bold bg-green-100 text-green-700 px-2 py-0.5 rounded-full uppercase tracking-wider'>
                                Vinculado
                              </span>
                            )}
                          </div>
                          <p className='text-sm text-gray-500'>
                            {global66Integrated
                              ? `Ya tienes Global66 vinculado con ${
                                  currentBusiness?.name || 'este negocio'
                                }`
                              : 'Conecta Luca con tu cuenta de Global66 para obtener tus movimientos en CLP'}
                          </p>
                        </div>
                        {!global66Integrated && (
                          <svg
                            className='w-6 h-6 text-gray-400 group-hover:text-primary group-hover:translate-x-1 transition-all'
                            fill='none'
                            stroke='currentColor'
                            viewBox='0 0 24 24'
                          >
                            <path
                              strokeLinecap='round'
                              strokeLinejoin='round'
                              strokeWidth={2}
                              d='M9 5l7 7-7 7'
                            />
                          </svg>
                        )}
                      </div>
                    </button>
                  </PlanRestrictedButton>
                )}

                <PlanRestrictedButton
                  checkBankLimit
                  message='Agregar más bancos'
                  keepEnabled
                  canAddAddon={true}
                  onClick={handleSelectOtherBanks}
                  className='w-full'
                >
                  <button className='w-full group relative overflow-hidden bg-white border-2 border-gray-200 rounded-2xl p-6 hover:border-green-400 hover:shadow-lg transition-all duration-300 ease-in-out'>
                    <div className='flex items-center space-x-4'>
                      <div className='flex-shrink-0 w-16 h-16 bg-gradient-to-br from-green-50 to-green-100 rounded-xl flex items-center justify-center p-1'>
                        <div className='grid grid-cols-2 gap-0.5 w-full h-full'>
                          <img
                            src={bancoChileLogo}
                            alt='Banco'
                            className='w-full h-full object-cover rounded-tl-lg'
                          />
                          <img
                            src={bancoEstadoLogo}
                            alt='Banco'
                            className='w-full h-full object-cover rounded-tr-lg'
                          />
                          <img
                            src={bancoSantanderLogo}
                            alt='Banco'
                            className='w-full h-full object-cover rounded-bl-lg'
                          />
                          <div className='bg-gray-100 rounded-br-lg flex items-center justify-center'>
                            <span className='text-xs font-bold text-gray-600'>+</span>
                          </div>
                        </div>
                      </div>
                      <div className='flex-1 text-left'>
                        <h3 className='text-lg font-semibold text-gray-800 group-hover:text-green-600 transition-colors'>
                          Conecta otros Bancos a través de Fintoc
                        </h3>
                        <p className='text-sm text-gray-500'>
                          Conecta con Banco de Chile, Estado, Santander y más
                        </p>
                      </div>
                      <svg
                        className='w-6 h-6 text-gray-400 group-hover:text-green-600 group-hover:translate-x-1 transition-all'
                        fill='none'
                        stroke='currentColor'
                        viewBox='0 0 24 24'
                      >
                        <path
                          strokeLinecap='round'
                          strokeLinejoin='round'
                          strokeWidth={2}
                          d='M9 5l7 7-7 7'
                        />
                      </svg>
                    </div>
                  </button>
                </PlanRestrictedButton>

                {CREDIT_CARDS_ALLOWED && (
                  <button
                    onClick={handleOpenCreditCardStatementModal}
                    className='w-full group relative overflow-hidden bg-white border-2 border-gray-200 rounded-2xl p-6 hover:border-primary hover:shadow-lg transition-all duration-300 ease-in-out'
                  >
                    <div className='flex items-center space-x-4'>
                      <div className='flex-shrink-0 w-16 h-16 bg-gradient-to-br from-primary/10 to-primary/20 rounded-xl flex items-center justify-center'>
                        <CreditCardIcon className='w-8 h-8 text-primary' />
                      </div>
                      <div className='flex-1 text-left'>
                        <h3 className='text-lg font-semibold text-gray-800 group-hover:text-primary transition-colors'>
                          Agregar tarjeta de crédito
                        </h3>
                        <p className='text-sm text-gray-500'>
                          Sube la cartola de tu tarjeta de crédito y registra sus movimientos
                        </p>
                      </div>
                      <svg
                        className='w-6 h-6 text-gray-400 group-hover:text-primary group-hover:translate-x-1 transition-all'
                        fill='none'
                        stroke='currentColor'
                        viewBox='0 0 24 24'
                      >
                        <path
                          strokeLinecap='round'
                          strokeLinejoin='round'
                          strokeWidth={2}
                          d='M9 5l7 7-7 7'
                        />
                      </svg>
                    </div>
                  </button>
                )}
              </div>

              <button
                type='button'
                className='mt-6 w-full text-sm text-gray-500 hover:text-gray-700 font-medium transition-colors'
                onClick={() => setShowConnectMethodModal(false)}
              >
                Cancelar
              </button>
            </div>
          </div>
        )}

        {showMercadoPagoInfoModal && (
          <div className='fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50'>
            <div className='bg-white rounded-2xl shadow-2xl p-8 w-[500px] max-h-[90vh] overflow-y-auto relative'>
              <h2 className='text-2xl font-semibold mb-2 text-gray-800 text-center'>
                Conecta tu cuenta de Mercado Pago
              </h2>

              {mercadoPagoIntegrated && (
                <p className='mb-4 text-center'>
                  <span className='inline-block text-xs font-bold bg-blue-100 text-blue-700 px-3 py-1 rounded-full uppercase tracking-wider'>
                    Estás agregando otra cuenta de Mercado Pago
                  </span>
                </p>
              )}

              <div className='mb-6 flex justify-center'>
                <img
                  src={mercadoPagoAuthImage}
                  alt='Mercado Pago Auth'
                  className='w-full max-w-md h-auto rounded-lg'
                />
              </div>

              <p className='mb-6 text-base text-gray-700 text-center leading-relaxed'>
                Se abrirá una nueva pestaña donde deberás indicar tu país y luego iniciar sesión en
                tu Mercado Pago. Luego, serás redirigido aquí nuevamente.
              </p>

              {!mercadoPagoIntegrated && (
                <div className='mb-4 text-center'>
                  <button
                    type='button'
                    onClick={() => {
                      setShowMercadoPagoInfoModal(false)
                      setShowMercadoPagoConnectModal(true)
                    }}
                    className='text-gray-700 hover:text-gray-900 text-sm font-medium transition-colors'
                  >
                    ¿Tienes un token de acceso? Haz click aquí
                  </button>
                </div>
              )}

              <div className='flex flex-col space-y-3'>
                <button
                  onClick={handleConfirmMercadoPago}
                  className='w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-xl transition-colors duration-200'
                >
                  Continuar
                </button>
                <button
                  type='button'
                  onClick={() => {
                    setShowMercadoPagoInfoModal(false)
                  }}
                  className='w-full bg-gray-100 hover:bg-gray-200 text-gray-700 font-semibold py-3 px-6 rounded-xl transition-colors duration-200'
                >
                  Cancelar
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Eliminado minimized state */}

        {showMercadoPagoConnectModal && (
          <div className='fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50'>
            <div className='bg-white rounded-2xl shadow-2xl p-8 w-[500px] max-h-[90vh] overflow-y-auto'>
              <h2 className='text-2xl font-semibold mb-4 text-gray-800 text-center'>
                Conectar MercadoPago con Token de Acceso
              </h2>

              <p className='mb-4 text-sm text-gray-600'>
                Si ya conoces cuál es tu token de acceso, copialo y pégalo aquí para poder integrar
                tu cuenta de Mercado Pago.
              </p>

              <div className='mb-6'>
                <textarea
                  value={mercadoPagoAccessToken}
                  onChange={e => setMercadoPagoAccessToken(e.target.value)}
                  placeholder='Pega aquí tu access token...'
                  className='w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none'
                  rows={2}
                  disabled={isConnectingMercadoPago}
                />
              </div>

              <div className='flex flex-col space-y-3'>
                <button
                  onClick={handleConnectMercadoPagoWithToken}
                  disabled={isConnectingMercadoPago || !mercadoPagoAccessToken.trim()}
                  className='w-full bg-green-600 hover:bg-green-700 disabled:bg-gray-400 disabled:cursor-not-allowed text-white font-semibold py-3 px-6 rounded-xl transition-colors duration-200'
                >
                  {isConnectingMercadoPago ? 'Conectando...' : 'Conectar'}
                </button>
                <button
                  type='button'
                  onClick={() => {
                    setShowMercadoPagoConnectModal(false)
                    setMercadoPagoAccessToken('')
                  }}
                  disabled={isConnectingMercadoPago}
                  className='w-full bg-gray-100 hover:bg-gray-200 disabled:bg-gray-300 text-gray-700 font-semibold py-3 px-6 rounded-xl transition-colors duration-200'
                >
                  Cancelar
                </button>
              </div>
            </div>
          </div>
        )}

        {SHOW_NEW_GLOBAL66_BANK && showGlobal66Modal && (
          <div className='fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50'>
            <div className='bg-white rounded-2xl shadow-2xl p-8 w-[820px] max-w-[95vw] max-h-[92vh] overflow-y-auto relative'>
              <button
                type='button'
                onClick={() => setShowGlobal66Modal(false)}
                className='absolute top-4 right-4 text-gray-400 hover:text-gray-600 text-2xl font-bold transition-colors z-10'
                aria-label='Cerrar'
              >
                ✕
              </button>
              <Global66IntegrationFlow
                key={global66ModalKey}
                variant='modal'
                initialIntegrated={false}
                initialBalance={null}
                onClose={() => setShowGlobal66Modal(false)}
                onStatusChange={integrated => setGlobal66Integrated(integrated)}
              />
            </div>
          </div>
        )}

        <AutomaticConciliationModal {...automaticConciliation} />

        <ExportToXlsxModal
          isOpen={isExportModalOpen}
          onClose={() => setIsExportModalOpen(false)}
          onExport={handleExport}
          title='Exportar Transacciones Bancarias'
          description='Se enviará un archivo Excel con las transacciones bancarias filtradas al email especificado'
          isLoading={isExporting}
        />

        <ModalCreditCardStatementIntro
          isOpen={showCreditCardStatementIntroModal}
          onClose={() => setShowCreditCardStatementIntroModal(false)}
          onNext={handleCreditCardStatementIntroNext}
          businessId={currentBusiness?.id}
        />

        <ModalCreditCardStatement
          isOpen={showCreditCardStatementModal}
          onClose={() => setShowCreditCardStatementModal(false)}
          businessId={currentBusiness?.id}
        />
      </div>
    </>
  )
}

export default List
